export const DEFAULT_DOCUMENT_TYPE = 'PV';

export const CLAIM_TYPE = {
  CORPOREL: 'Corporel',
};

export const DOCUMENT_NAME = 'Document';
